<template>
   <div>
    <div class="row">
      <div class="col-5">
        <div class="container login-form">
          <img src=".././assets/images/Logo.svg" alt="">
          <form class="form-set" @submit.prevent="handleSubmit">
            <div class="form-container">
              <p style="color:red" v-text="error"></p>

              <div class="form-group">
                <label for="username">New password</label>
                <input type="password" class="form-control" id="password"
                  placeholder="New password" v-model="password">
              </div>
              <a href="mailto:support@konnect-us.com">Contact support</a>
            </div>
            <button type="submit" class="btn btn-primary btn-login">Change password</button>
          </form>
        </div>
      </div>
      <div class="col-7">
        <img src=".././assets/images/img1@2x-no-bg-5.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChangePassword',
    data() {
      return {
        password: '',
      };
    },
    computed: {
      error() {
        return this.$store.state.auth.error;
      },
    },
    methods: {
      handleSubmit() {
        const data = {
          token: this.$route.params.token,
          password: this.password,
        };

        this.$store.dispatch('auth/changePassword', data)
          .then(() => {
            this.$session.set('success', 'Password changed successfully');
            this.$router.push('/login');
          });
      },
    },
  };
</script>
